import { type Editor } from 'grapesjs'

import ExecuteButtonComp from '@/components/embeds/embedSetupConfig/config/component/ExecuteButtonComp.vue'
import ExecuteMatrixComp from '@/components/embeds/embedSetupConfig/config/component/ExecuteMatrixComp.vue'
import FontsizeComp from '@/components/embeds/embedSetupConfig/config/component/FontsizeComp.vue'
import IdeComp from '@/components/embeds/embedSetupConfig/config/component/IdeComp.vue'
import InputArgsCompVue from '@/components/embeds/embedSetupConfig/config/component/InputArgsComp.vue'
import InputFileCompVue from '@/components/embeds/embedSetupConfig/config/component/InputFileComp.vue'
import InteractiveToggleComp from '@/components/embeds/embedSetupConfig/config/component/InteractiveToggleComp.vue'
import LanguagesListComp from '@/components/embeds/embedSetupConfig/config/component/LanguagesListComp.vue'
import LibsComp from '@/components/embeds/embedSetupConfig/config/component/LibsComp.vue'
import OutputComp from '@/components/embeds/embedSetupConfig/config/component/OutputComp.vue'
import OutputFileComp from '@/components/embeds/embedSetupConfig/config/component/OutputFileComp.vue'
import PostToComp from '@/components/embeds/embedSetupConfig/config/component/PostToComp.vue'
import STDINComp from '@/components/embeds/embedSetupConfig/config/component/STDINComp.vue'
import VersionListComp from '@/components/embeds/embedSetupConfig/config/component/VersionListComp.vue'
export interface IDevice {
  id: number
  name: string
  icon: string
  width: string
  widthMedia: string
}

export const EMBEDCONSTANTS = {
  EDITORCONTAINER: 'editor-container',
  COMPONENTCONTAINER: 'component-container',
  STYLECONTAINER: 'style-container'
}

export const DEVICES: IDevice[] = [
  {
    id: 1,
    name: 'Mobile',
    icon: 'fa-mobile-screen-button',
    width: '360px',
    widthMedia: '360px'
  },
  {
    id: 2,
    name: 'Tablet',
    icon: 'fa-tablet-screen-button',
    width: '601px',
    widthMedia: '601px'
  },
  {
    id: 3,
    name: 'Desktop',
    icon: 'fa-display',
    width: '2000px',
    widthMedia: '2000px'
  }
]
interface IJdoodleBlock {
  category: string
  id: string
  label: string
  singleton: boolean
  vueComponent: any
  content: {
    name: string
    content: string
    resizable: boolean
    droppable: boolean
    commands: string[]
  }
  configStyle?: {
    name: string
    open: boolean
    buildProps: string[]
    properties: any[]
  }
}
export const COMMANDSNAMES = {
  SELECTPARENT: 'select-parent',
  SHOWSTYLEMANAGER: 'show-style-manager',
  COPY: 'copy',
  MOVE: 'move',
  DELETE: 'delete'
}
export const COMMANDS = [
  {
    id: COMMANDSNAMES.SELECTPARENT,
    obj: {
      attributes: { class: 'fa fa-arrow-up' },
      //eslint-disable-next-line
      command: (editor: Editor) => {
        const selected = editor.getSelected()
        if (selected && selected.parent()) {
          editor.select(selected.parent())
        }
      }
    }
  },
  {
    id: COMMANDSNAMES.SHOWSTYLEMANAGER,
    obj: {
      attributes: { class: 'fa fa-gear' },
      command: 'show-style-manager'
    }
  },
  {
    id: COMMANDSNAMES.COPY,
    obj: {
      attributes: { class: 'fa fa-copy' },
      command: 'tlb-clone'
    }
  },
  {
    id: COMMANDSNAMES.MOVE,
    obj: {
      attributes: { class: 'fa fa-arrows' },
      command: 'tlb-move'
    }
  },
  {
    id: COMMANDSNAMES.DELETE,
    obj: {
      attributes: { class: 'fa fa-trash' },
      command: 'tlb-delete'
    }
  }
]
export const CATEGORIES = {
  HTML: 'HTML Components',
  JDoodle: 'JDoodle Components'
}
export const TABBLOCKS = {
  Tabs: {
    commands: [
      COMMANDSNAMES.SELECTPARENT,
      COMMANDSNAMES.MOVE,
      COMMANDSNAMES.DELETE,
      COMMANDSNAMES.SHOWSTYLEMANAGER
    ],
    configStyle: {
      name: 'Tabs Styles',
      open: true,
      buildProps: [
        'width',
        'height',
        'margin',
        'padding',
        'background-color',
        'border-radius',
        'border',
        'box-shadow'
      ]
    }
  },
  'Tab Contents': {
    commands: [COMMANDSNAMES.SELECTPARENT, COMMANDSNAMES.MOVE, COMMANDSNAMES.SHOWSTYLEMANAGER],
    configStyle: {
      name: 'Tab Contents Styles',
      open: true,
      buildProps: [
        'width',
        'height',
        'margin',
        'padding',
        'background-color',
        'border-radius',
        'border',
        'box-shadow'
      ]
    }
  },
  'Tab Container': {
    commands: [COMMANDSNAMES.SELECTPARENT, COMMANDSNAMES.MOVE, COMMANDSNAMES.SHOWSTYLEMANAGER],
    configStyle: {
      name: 'Tab Container Styles',
      open: true,
      buildProps: [
        'width',
        'height',
        'margin',
        'padding',
        'background-color',
        'border-radius',
        'border',
        'box-shadow'
      ]
    }
  },
  Tab: {
    commands: [
      COMMANDSNAMES.SELECTPARENT,
      COMMANDSNAMES.MOVE,
      COMMANDSNAMES.COPY,
      COMMANDSNAMES.DELETE,
      COMMANDSNAMES.SHOWSTYLEMANAGER
    ],
    configStyle: {
      name: 'Tab Styles',
      open: true,
      buildProps: [
        'width',
        'height',
        'margin',
        'padding',
        'background-color',
        'border-radius',
        'border',
        'box-shadow',
        'font-family',
        'font-size',
        'font-weight',
        'color',
        'text-align',
        'letter-spacing',
        'line-height'
      ]
    }
  }
}

const HTMLBLOCKS = [
  {
    category: CATEGORIES.HTML,
    id: 'flex',
    label: 'Flex',
    attributes: { class: 'fa fa-th-large', style: 'font-size: 20px;' },
    content: {
      name: 'flex',
      type: 'default',
      tagName: 'div',
      style: {
        display: 'flex',
        width: '100%',
        height: '100px'
      },
      resizable: true,
      droppable: true,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Flex Styles',
      open: true,
      buildProps: [
        'width',
        'height',
        'flex-direction',
        'justify-content',
        'align-items',
        'align-content',
        'flex-wrap',
        'flex-flow'
      ],
      properties: [
        {
          id: 'flex-direction',
          name: 'Direction',
          type: 'select',
          options: [
            { value: 'row', name: 'Row' },
            { value: 'row-reverse', name: 'Row Reverse' },
            { value: 'column', name: 'Column' },
            { value: 'column-reverse', name: 'Column Reverse' }
          ]
        },
        {
          id: 'justify-content',
          name: 'Justify',
          type: 'select',
          options: [
            { value: 'flex-start', name: 'Start' },
            { value: 'flex-end', name: 'End' },
            { value: 'center', name: 'Center' },
            { value: 'space-between', name: 'Space Between' },
            { value: 'space-around', name: 'Space Around' },
            { value: 'space-evenly', name: 'Space Evenly' }
          ]
        },
        {
          id: 'align-items',
          name: 'Align Items',
          type: 'select',
          options: [
            { value: 'flex-start', name: 'Start' },
            { value: 'flex-end', name: 'End' },
            { value: 'center', name: 'Center' },
            { value: 'baseline', name: 'Baseline' },
            { value: 'stretch', name: 'Stretch' }
          ]
        },
        {
          id: 'align-content',
          name: 'Align Content',
          type: 'select',
          options: [
            { value: 'flex-start', name: 'Start' },
            { value: 'flex-end', name: 'End' },
            { value: 'center', name: 'Center' },
            { value: 'space-between', name: 'Space Between' },
            { value: 'space-around', name: 'Space Around' },
            { value: 'stretch', name: 'Stretch' }
          ]
        },
        {
          id: 'flex-wrap',
          name: 'Wrap',
          type: 'select',
          options: [
            { value: 'nowrap', name: 'No Wrap' },
            { value: 'wrap', name: 'Wrap' },
            { value: 'wrap-reverse', name: 'Wrap Reverse' }
          ]
        },
        {
          id: 'flex-flow',
          name: 'Flow',
          type: 'select',
          options: [
            { value: 'row nowrap', name: 'Row No Wrap' },
            { value: 'row wrap', name: 'Row Wrap' },
            { value: 'row wrap-reverse', name: 'Row Wrap Reverse' },
            { value: 'column nowrap', name: 'Column No Wrap' },
            { value: 'column wrap', name: 'Column Wrap' },
            { value: 'column wrap-reverse', name: 'Column Wrap Reverse' }
          ]
        }
      ]
    }
  },
  {
    category: CATEGORIES.HTML,
    id: 'section',
    label: 'Section',
    attributes: { class: 'fa fa-square', style: 'font-size: 20px;' },
    content: {
      name: 'section',
      type: 'default',
      tagName: 'section',
      style: {
        width: '100%',
        height: '100px'
      },
      resizable: true,
      droppable: true,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Section Styles',
      open: true,
      buildProps: [
        'width',
        'height',
        'margin',
        'padding',
        'background-color',
        'background',
        'border-radius',
        'border',
        'box-shadow'
      ]
    }
  },
  {
    category: CATEGORIES.HTML,
    id: 'header',
    label: 'Header',
    attributes: { class: 'fa fa-header', style: 'font-size: 20px;' },
    content: {
      name: 'header',
      type: 'text',
      tagName: 'h1',
      content: 'Insert your header text here',
      style: {
        height: 'fit-content',
        margin: '0px'
      },
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Header Styles',
      open: true,
      buildProps: [
        'font-family',
        'font-size',
        'font-weight',
        'color',
        'text-align',
        'text-decoration',
        'letter-spacing',
        'line-height'
      ],
      properties: [
        {
          id: 'text-decoration',
          name: 'Decoration',
          type: 'select',
          options: [
            { value: 'none', name: 'None' },
            { value: 'underline', name: 'Underline' },
            { value: 'overline', name: 'Overline' },
            { value: 'line-through', name: 'Line-through' }
          ]
        }
      ]
    }
  },
  {
    category: CATEGORIES.HTML,
    id: 'text',
    label: 'Text',
    attributes: { class: 'fa fa-font', style: 'font-size: 20px;' },
    content: {
      name: 'text',
      type: 'text',
      content: 'Insert your text here',
      style: { height: 'fit-content' },
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Text Styles',
      open: true,
      buildProps: [
        'font-family',
        'font-size',
        'font-weight',
        'color',
        'letter-spacing',
        'line-height',
        'text-align',
        'text-shadow',
        'text-decoration'
      ],
      properties: [
        {
          id: 'text-decoration',
          name: 'Decoration',
          type: 'select',
          options: [
            { value: 'none', name: 'None' },
            { value: 'underline', name: 'Underline' },
            { value: 'overline', name: 'Overline' },
            { value: 'line-through', name: 'Line-through' }
          ]
        }
      ]
    }
  },
  {
    category: CATEGORIES.HTML,
    id: 'image',
    label: 'Image',
    attributes: { class: 'fa fa-image', style: 'font-size: 20px;' },
    content: {
      name: 'image',
      type: 'image',
      style: {},
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Image Styles',
      open: true,
      buildProps: ['width', 'height', 'border-radius', 'border', 'box-shadow']
    },
    activate: true
  }
]
export const JDOODLEBLOCKSNAMES = {
  IDECOMP: 'IdeComp',
  OUTPUTCOMP: 'OutputComp',
  EXECUTECOMP: 'ExecuteComp',
  LANGUAGELIST: 'LanguagesListComp',
  VERSIONLIST: 'VersionListComp',
  STDINARGS: 'stdinArgs',
  INPUTARGS: 'inputArgs',
  INTERACTIVETOGGLE: 'interactiveToggle',
  LIBSCOMP: 'LibsComp',
  INPUTFILECOMP: 'InputFileComp',
  OUTPUTFILECOMP: 'OutputFileComp',
  EXEMATRIX: 'ExeMatrix',
  FONTSIZE: 'fontSize',
  EXECUTEBTN: 'executeBtn',
  POSTTOJDOODLE: 'postToJdoodle'
}
export const JDOODLEBLOCKS: IJdoodleBlock[] = [
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.IDECOMP,
    label: 'Code Editor',
    singleton: true,
    vueComponent: IdeComp,
    content: {
      name: JDOODLEBLOCKSNAMES.IDECOMP,
      content: `<div id="${JDOODLEBLOCKSNAMES.IDECOMP}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Code Editor',
      open: true,
      buildProps: ['readOnly', 'lineNumber', 'autoCompletion', 'autoGrow', 'width', 'height'],
      properties: [
        {
          id: 'readOnly',
          name: 'Read-Only',
          type: 'select',
          options: [
            { id: 'true', label: 'Yes' },
            { id: 'false', label: 'No' }
          ],
          default: 'false'
        },
        {
          id: 'lineNumber',
          name: 'Line Number',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'autoCompletion',
          name: 'Auto Completion',
          type: 'select',
          options: [
            { id: 'true', label: 'On' },
            { id: 'false', label: 'Off' }
          ],
          default: 'false'
        },
        {
          id: 'autoGrow',
          name: 'Auto Grow',
          type: 'select',
          options: [
            { id: 'true', label: 'Auto Grow' },
            { id: 'false', label: 'Fixed' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.OUTPUTCOMP,
    label: 'Output',
    singleton: true,
    vueComponent: OutputComp,
    content: {
      name: JDOODLEBLOCKSNAMES.OUTPUTCOMP,
      content: `<div id="${JDOODLEBLOCKSNAMES.OUTPUTCOMP}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Output',
      open: true,
      buildProps: ['autoGrow', 'fontSize', 'width', 'height'],
      properties: [
        {
          id: 'autoGrow',
          name: 'Auto Grow',
          type: 'select',
          options: [
            { id: 'true', label: 'Auto Grow' },
            { id: 'false', label: 'Fixed' }
          ],
          default: 'true'
        },
        {
          id: 'fontSize',
          name: 'Font Size',
          type: 'number',
          units: ['px'],
          min: 11,
          max: 25,
          default: 12
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.LANGUAGELIST,
    label: 'Language List',
    singleton: true,
    vueComponent: LanguagesListComp,
    content: {
      name: JDOODLEBLOCKSNAMES.LANGUAGELIST,
      content: `<div id="${JDOODLEBLOCKSNAMES.LANGUAGELIST}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Language List',
      open: true,
      buildProps: [
        'hideTitle',
        'titleName',
        'display',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'Select Language:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.VERSIONLIST,
    label: 'Version List',
    singleton: true,
    vueComponent: VersionListComp,
    content: {
      name: JDOODLEBLOCKSNAMES.VERSIONLIST,
      content: `<div id="${JDOODLEBLOCKSNAMES.VERSIONLIST}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Version List',
      open: true,
      buildProps: [
        'hideTitle',
        'titleName',
        'display',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'Select Version:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.STDINARGS,
    label: 'STDIN Input',
    singleton: true,
    vueComponent: STDINComp,
    content: {
      name: JDOODLEBLOCKSNAMES.STDINARGS,
      content: `<div id="${JDOODLEBLOCKSNAMES.STDINARGS}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'STDIN Input',
      open: true,
      buildProps: [
        'width',
        'height',
        'hideTitle',
        'titleName',
        'display',
        'lines',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'STDIN Input:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        },
        {
          id: 'lines',
          name: 'Lines',
          type: 'number',
          min: 1,
          max: 10,
          default: 2
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.INPUTARGS,
    label: 'Input Arguments',
    singleton: true,
    vueComponent: InputArgsCompVue,
    content: {
      name: JDOODLEBLOCKSNAMES.INPUTARGS,
      content: `<div id="${JDOODLEBLOCKSNAMES.INPUTARGS}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Input Arguments',
      open: true,
      buildProps: [
        'hideTitle',
        'titleName',
        'display',
        'lines',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'Input Arguments:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        },
        {
          id: 'lines',
          name: 'Lines',
          type: 'number',
          min: 1,
          max: 10,
          default: 2
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.INTERACTIVETOGGLE,
    label: 'Interactive Toggle',
    singleton: true,
    vueComponent: InteractiveToggleComp,
    content: {
      name: JDOODLEBLOCKSNAMES.INTERACTIVETOGGLE,
      content: `<div id="${JDOODLEBLOCKSNAMES.INTERACTIVETOGGLE}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Interactive Toggle',
      open: true,
      buildProps: [
        'hideTitle',
        'titleName',
        'display',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'Interactive Mode:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.LIBSCOMP,
    label: 'External Library',
    singleton: true,
    vueComponent: LibsComp,
    content: {
      name: JDOODLEBLOCKSNAMES.LIBSCOMP,
      content: `<div id="${JDOODLEBLOCKSNAMES.LIBSCOMP}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'External Library',
      open: true,
      buildProps: [
        'canEdit',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'text-align',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'canEdit',
          name: 'Allow users to Modify',
          type: 'select',
          options: [
            { id: 'true', label: 'Yes' },
            { id: 'false', label: 'No' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.INPUTFILECOMP,
    label: 'Input Files',
    singleton: true,
    vueComponent: InputFileCompVue,
    content: {
      name: JDOODLEBLOCKSNAMES.INPUTFILECOMP,
      content: `<div id="${JDOODLEBLOCKSNAMES.INPUTFILECOMP}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Input Files',
      open: true,
      buildProps: [
        'canUpload',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'text-align',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'canUpload',
          name: 'Allow users to upload files',
          type: 'select',
          options: [
            { id: 'true', label: 'Yes' },
            { id: 'false', label: 'No' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.OUTPUTFILECOMP,
    label: 'Output Files',
    singleton: true,
    vueComponent: OutputFileComp,
    content: {
      name: JDOODLEBLOCKSNAMES.OUTPUTFILECOMP,
      content: `<div id="${JDOODLEBLOCKSNAMES.OUTPUTFILECOMP}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Output Files',
      open: true,
      buildProps: [
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'text-align',
        'letter-spacing'
      ],
      properties: []
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.EXEMATRIX,
    label: 'Execution Matrices',
    singleton: true,
    vueComponent: ExecuteMatrixComp,
    content: {
      name: JDOODLEBLOCKSNAMES.EXEMATRIX,
      content: `<div id="${JDOODLEBLOCKSNAMES.EXEMATRIX}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Execution Matrices',
      open: true,
      buildProps: [
        'hideTitle',
        'titleName',
        'display',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'text-align',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'Execution Matrices:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.FONTSIZE,
    label: 'Editor Font Size',
    singleton: true,
    vueComponent: FontsizeComp,
    content: {
      name: JDOODLEBLOCKSNAMES.FONTSIZE,
      content: `<div id="${JDOODLEBLOCKSNAMES.FONTSIZE}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Editor Font Size',
      open: true,
      buildProps: [
        'hideTitle',
        'titleName',
        'display',
        'width',
        'height',
        'font-size',
        'font-family',
        'color',
        'letter-spacing'
      ],
      properties: [
        {
          id: 'hideTitle',
          name: 'Hide Title',
          type: 'select',
          options: [
            { id: 'true', label: 'Show' },
            { id: 'false', label: 'Hide' }
          ],
          default: 'true'
        },
        {
          id: 'titleName',
          name: 'Title Name',
          type: 'text',
          default: 'Editor Font Size:'
        },
        {
          id: 'display',
          name: 'Display',
          type: 'select',
          options: [
            { id: 'true', label: 'Row' },
            { id: 'false', label: 'Col' }
          ],
          default: 'true'
        }
      ]
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.EXECUTEBTN,
    label: 'Execute Button',
    singleton: true,
    vueComponent: ExecuteButtonComp,
    content: {
      name: JDOODLEBLOCKSNAMES.EXECUTEBTN,
      content: `<div id="${JDOODLEBLOCKSNAMES.EXECUTEBTN}"></div>`,
      resizable: true,
      droppable: false,
      commands: [
        COMMANDSNAMES.SELECTPARENT,
        COMMANDSNAMES.MOVE,
        COMMANDSNAMES.DELETE,
        COMMANDSNAMES.SHOWSTYLEMANAGER
      ]
    },
    configStyle: {
      name: 'Execute Button',
      open: true,
      buildProps: [
        'width',
        'height',
        'margin',
        'padding',
        'font-size',
        'font-family',
        'letter-spacing',
        'color',
        'background-color',
        'border-radius',
        'border'
      ],
      properties: []
    }
  },
  {
    category: CATEGORIES.JDoodle,
    id: JDOODLEBLOCKSNAMES.POSTTOJDOODLE,
    label: 'Post to JDoodle',
    singleton: true,
    vueComponent: PostToComp,
    content: {
      name: JDOODLEBLOCKSNAMES.POSTTOJDOODLE,
      content: `<div id="${JDOODLEBLOCKSNAMES.POSTTOJDOODLE}"></div>`,
      resizable: false,
      droppable: false,
      commands: [COMMANDSNAMES.SELECTPARENT]
    }
  }
]
export const BLOCKS = [...HTMLBLOCKS, ...JDOODLEBLOCKS]
